import { IStatusProgress } from "@app/shared-widgets/shared-widgets.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const statusProgressAdapter: EntityAdapter<IStatusProgress> = createEntityAdapter<IStatusProgress>({
	selectId: progress => progress.accountId
});